import favicon from './favicon.jpg'
import logoStart from './logo-start.png'
import leftCount from './left-count.png'
import rightCount from './right-count.png'
import countSm from './count-sm.png'
import proKubok from './pro-kubok.png'
import imgNews from './img-news.png'
import prev from './prev.png'
import next from './next.png'
import newsBottom from './news-bottom.png'
import dropdown from './dropdown.png'
import iconClose from './icon-close.png'
import attentionL1 from './attention1.png'
import attentionL2 from './attention2.png'
import upButton from './up-button.png'
import preview from './preview-video.png'
import play from './play.png'
import avatar from './person.png'
import footerMedia from './footer-media.png'
import legendTest from './legend-test.png'
import car from './nom-car.jpg'
import service from './nom-service.jpg'
import kitchen from './nom-kitchen.jpg'
import chick from './nom-chick.jpg'
import video from './nom-video.png'

import mapColorIcon from './map-color.png'
import mapGreyIcon from './map-grey.png'

export const img = {
  favicon,
  logoStart,
  leftCount,
  rightCount,
  countSm,
  proKubok,
  imgNews,
  prev,
  next,
  newsBottom,
  dropdown,
  iconClose,
  attentionL1,
  attentionL2,
  upButton,
  play,
  avatar,
  preview,
  footerMedia,
  legendTest,
  car,
  service,
  kitchen,
  chick,
  video,
  mapColorIcon,
  mapGreyIcon,
}
